import React from "react";
import { Helmet } from "react-helmet-async";
import HeroSection from "../components/HeroSection";
import WhyChooseAikyam from "../components/WhyChooseAikyam";
import TrainSmarter from "../components/TrainSmarter";
import PremiumServices from "../components/PremiumServices";
import SlidingCardSection from "../components/SlidingCardSection";
import Partners from "../components/Partners";
import BlogPostsSection from "../components/BlogPostsSection";
import TestimonialsSection from "../components/TestimonialsSection";
import CommunityAndFAQSection from "../components/CommunityAndFAQSection";

const Home = () => {
  return (
    <div>
      <Helmet>
        <title>No. 1 Physiotherapy & Best Strength and Conditioning in Udupi | Aikyam</title>
        <meta 
          name="description" 
          content="Visit Aikyam Sports Science, the No. 1 and best center for advanced physiotherapy, sports injury rehabilitation, and elite strength & conditioning in Udupi and Manipal." 
        />
        <meta 
          name="keywords" 
          content="no 1 physiotherapy udupi, best physiotherapy udupi, top rehab center udupi, best strength and conditioning udupi, best sports science clinic manipal, top fitness center mangalore" 
        />
      </Helmet>

      <HeroSection />
      <WhyChooseAikyam />
      <TrainSmarter />
      <PremiumServices />
      
      <SlidingCardSection
        heading="Proud Athletes"
        subheading="These are our proud athletes who have competed at the state & nationals level using the best sports science protocols"
        type="athletes"
        id="athletes"
      />

      <Partners />
      <BlogPostsSection />
      <TestimonialsSection />
      
      <SlidingCardSection
        heading="OUR TEAM"
        subheading="Meet our Best physiotherapists, S&C coaches and top tech experts"
        type="team"
        id="team"
      />
      
      <CommunityAndFAQSection />
    </div>
  );
};

export default Home;